/** Owner policy, 28 October 2026. Applies only to Singles Chain, not settlement. */
export function isSinglesUnderSelection(
  market: unknown,
  selection?: unknown,
  canonicalCode?: unknown,
): boolean {
  const normalize = (value: unknown) =>
    String(value ?? "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  const under = /(?:^|_)under(?:_|$|\d)/;
  // Canonical identity and selected direction take precedence over a generic O/U label.
  if (under.test(normalize(canonicalCode)) || under.test(normalize(selection))) return true;
  const label = normalize(market).replace(/(?:^|_)over_under(?=_|$)/g, "_ou");
  return under.test(label);
}
